/**
 * Operation name of layer.visibility.query.gql. Refetched by the saves that
 * move a gate the layer row itself does not carry: the country list and the
 * availability. Publish state and categories come off the layer row and
 * follow the cache on their own.
 */
export const LAYER_VISIBILITY_QUERY_NAME = "LayerVisibilityQuery"

/** FeatureAvailabilityTypeCode meaning "available for all" (common.FeatureAvailabilityTypes). */
export const FEATURE_AVAILABILITY_ALL = 1
